import * as React from "react";
import { Table } from "react-bootstrap";
import { CreateOrderPosition } from "../../../../../stores";
import { formatMoney } from "../../../../../common/Formatting";

interface IProps {
    positions: CreateOrderPosition[];
}



export const ConfirmationTable: React.StatelessComponent<IProps> = (props) => {

    return <Table striped bordered className="table-xxs">
        <thead>
            <tr>
                <th className="text-center">#</th>
                <th className="text-center">Бренд</th>
                <th className="text-center">Артикул</th>
                <th>Описание</th>
                <th className="text-center">Срок поставки</th>
                <th className="text-center">Цена продажи</th>
                <th className="text-center">Количество</th>
            </tr>
        </thead>
        <tbody>
            {props.positions.map((w, index) => <tr key={index}>
                <td key={index}>{index + 1}</td>
                <td className="text-center">{w.brand}</td>
                <td className="text-center">{w.article}</td>
                <td>{w.description}</td>
                <td className="text-center">{w.deliveryTimeString}</td>
                <td className="text-center">{w.newCostSale || w.costSale}</td>
                <td className="text-center">{w.count}</td>
            </tr>)}
            <tr>
                <td className="text-right" colSpan={5}>{'Итого:'}</td>
                <td className="text-center">
                    <strong>{formatMoney(props.positions.reduce((a: number, b) => a + ((b.newCostSale || b.costSale) * b.count), 0))}</strong>
                </td>
                <td className="text-center">
                    <strong>{props.positions.reduce((a: number, b) => a + b.count, 0)}</strong>
                </td>
            </tr>
        </tbody>
    </Table>
}